import React, { useEffect, useState } from "react";
import CrearComidas from "../../../components/admin/comidas/comidas";
import ListadoComidas from "../../../components/admin/comidas/listadoComidas";

const initialState = {
    nombre: "",
    costo: "", 
    hora_inicio: "",
    hora_fin: "",
};


const Comidas = () => {
    const [updateList, setUpdateList] = useState(false);
    const [type, setType] = useState("save");
    const [state, setState] = useState(initialState);
    useEffect(() => {
      return () => {};
    }, []);
  
    const updateListFn = () => {
      setUpdateList(!updateList);
    };
  
    const resetState = () => {
      setState(initialState);
    };
    return (
      <div className="h-100 px-3 bgfondo2 d-flex justify-content-start flex-column ">
        <CrearComidas
          updateListFn={updateListFn}
          state={state}
          setState={setState}
          type={type}
          setType={setType}
          resetState={resetState}
        />
        <ListadoComidas
          updateList={updateList}
          updateListFn={updateListFn}
          setState={setState}
          setType={setType}
        />
      </div>
    );
  };
  
  export default Comidas;